import React from 'react';
import { Drawer, Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SidebarNav from './SidebarNav';

interface MobileNavDrawerProps {
    open: boolean;
    onClose: () => void;
}

/**
 * The small-screen navigation surface: a temporary Drawer over a scrim.
 *
 * It renders `SidebarNav`, so it shows exactly the modules the desktop sidebar shows — the
 * permission gates live in `moduleCatalog` + `useModuleVisibility` and are not duplicated here.
 * A temporary Drawer closes on scrim tap and on Escape for free; we additionally close on
 * navigation so following a link does not leave the drawer covering the page you asked for.
 */
const MobileNavDrawer = ({ open, onClose }: MobileNavDrawerProps) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        onClose();
        logout();
        navigate('/login');
    };

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            ModalProps={{ keepMounted: true }} // faster first open on low-end phones
            PaperProps={{
                sx: {
                    width: 290,
                    maxWidth: '85vw',
                    backgroundColor: '#2c3e50',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                <SidebarNav collapsed={false} onNavigate={onClose} />
            </Box>
            <Box className="logout-section" sx={{ flexShrink: 0 }}>
                <button onClick={handleLogout} className="logout-button">
                    <span className="icon">🚪</span>
                    Logout
                </button>
            </Box>
        </Drawer>
    );
};

export default MobileNavDrawer;
